import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/recaptcha";
import VueClipboard from "vue-clipboard2";

import VueMeta from "vue-meta";
import NotifyPlugin from "./plugins/notify";
import IconsPlugin from "@/plugins/icons";

import DOMPurify from "dompurify";

import SanitizePlugin from "@/plugins/sanitize"; // 白名單新增

import { initExternalLinkGuard } from "./plugins/external-link-guard";
import { initNativeApp } from "@/utils/nativeApp";
import { migrateLegacySavedPassword } from "@/utils/savedLogin";

import BrowserGuard from "./components/BrowserGuard.vue";
Vue.component("BrowserGuard", BrowserGuard);

import formatPrice from "@/utils/formatPrice";
Vue.prototype.$formatPrice = formatPrice;

Vue.use(IconsPlugin);
Vue.use(VueMeta);
Vue.use(NotifyPlugin);

Vue.use(VueClipboard);
Vue.config.productionTip = false;

Vue.use(SanitizePlugin);

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "IMG") {
    node.removeAttribute("width");
    node.removeAttribute("height");
    if (node.hasAttribute("style")) {
      // 粗略清掉 style 中的寬高
      const s = node
        .getAttribute("style")
        .replace(/width\s*:\s*[^;]+;?/gi, "")
        .replace(/height\s*:\s*[^;]+;?/gi, "");
      if (s.trim()) node.setAttribute("style", s);
      else node.removeAttribute("style");
    }
    node.setAttribute("loading", "lazy");
  }
});

Vue.directive("safe-html", {
  bind(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value || "");
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = DOMPurify.sanitize(binding.value || "");
    }
  },
});

// 建議先 log 一下，確定有跑
console.info("[ExtGuard] booting...");

initExternalLinkGuard({
  store,
  whitelist: [
    "*.kf-9595.com",
    "*.king-fong.com",
    "*kingfong9595.wordpress.com",
  ],
  safariMode: "confirm", // ★ 只在 Safari 走同步 confirm，不會先開空白視窗
  preopen: "auto", // 保留原邏輯（非 Safari 也不會預開）
});

// 原生 App：接住第三方登入完成後回到 App 的 App Link（網頁上不做任何事）
initNativeApp(router);
// 新版 App：舊版明文存的密碼搬進手機 Keystore（網頁版等使用者到登入頁再處理），見 utils/savedLogin.js
migrateLegacySavedPassword();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event("render-event"));
    }, 5000);
  },
}).$mount("#app");
